import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import Plugins from '@/plugins'
import roundNum from '@/mixins/roundNum'
import Vuelidate from 'vuelidate'
import _ from 'lodash'
import VueYoutube from 'vue-youtube'
import shared from '@/shared'
import '@babel/polyfill'
import 'typeface-montserrat/index.css'
import '@/assets/scss/custom.scss'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import Package from '../package.json'

if (process.env.VUE_APP_BUGSNAG_KEY) {
    Bugsnag.start({
        appVersion: Package.version,
        apiKey: process.env.VUE_APP_BUGSNAG_KEY,
        plugins: [new BugsnagPluginVue()],
        onError: function(event) {
            let user = store.getters['auth/user']
            event.setUser(user.id, user.email, user.name)
            event.addMetadata('tenant', {
                code: store.getters['auth/tenantCode'],
            })
        },
    })

    const bugsnagVue = Bugsnag.getPlugin('vue')
    bugsnagVue.installVueErrorHandler(Vue)
}

Vue.use(Vuelidate)
Vue.use(Plugins)
Vue.use(VueYoutube)
Vue.use(shared)

Vue.config.productionTip = false

Vue.mixin({
    methods: {
        can(permission) {
            let user = this.$store.getters['auth/user']
            if (!user) return false

            let permissions = _.reduce(
                user.permissions,
                (all, each) => {
                    all.push(each.name)
                    return all
                },
                [],
            )

            return permissions.includes(permission)
        },
    },
})
Vue.mixin(roundNum)

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
}).$mount('#app')
